<itl-wizard-page
  [showOnlyCancel]="true"
  (cancelClicked)="modalController.dismiss()"
  pageTitleTransPath="crossTherapy.createDocument"
  [isSinglePage]="true"
>
  <itl-loading-indicator *ngIf="busy" style="justify-content: center"></itl-loading-indicator>
  <ng-container *ngIf="!busy">
    <itl-detail-item *ngIf="serviceTaskViewModel">
      <itl-detail-item-icon>
        <ion-icon [name]="serviceTaskViewModel.therapyIcon"></ion-icon>
      </itl-detail-item-icon>
      <div>
        <span>{{ 'serviceTask.details.therapy' | translate }}: </span>
        <span class="bold">{{ serviceTaskViewModel.therapyName }} </span>
      </div>
      <div>
        <span>{{ 'serviceTask.details.therapyType' | translate }}: </span>
        <span class="bold">{{ serviceTaskViewModel.therapyTypeName }} </span>
      </div>
      <div *ngIf="serviceTask.woundLocation">
        <span>{{ 'serviceTask.details.woundLocation' | translate }}: </span>
        <span class="bold">{{ serviceTaskViewModel.woundLocation | woundLocation }}</span>
      </div>
    </itl-detail-item>

    <ion-item-group>
      <ion-item-divider color="medium">
        {{ 'audit.filter.templates' | translate }}
      </ion-item-divider>
      <itl-search-filter-bar
        [showFilter]="false"
        (searchValueReset)="clearSearch()"
        (searchValueChanged)="search($event)"
        [translate]="'Suche'"
      >
      </itl-search-filter-bar>
      <itl-loading-indicator *ngIf="loading"></itl-loading-indicator>
      <div *ngIf="!loading">
        <ion-item *ngFor="let template of items$ | async" (click)="createAudit(template)" class="template-item">
          <div *ngIf="template.draft" class="draft">Entwurf</div>
          <h3 [ngClass]="{ hasPayer: template.payer }">{{ template.title }}</h3>
        </ion-item>
      </div>
    </ion-item-group>
  </ng-container>
</itl-wizard-page>
